import { render, staticRenderFns } from "./popLogistics.vue?vue&type=template&id=1bbb28dc&scoped=true"
import script from "./popLogistics.vue?vue&type=script&lang=js"
export * from "./popLogistics.vue?vue&type=script&lang=js"
import style0 from "./popLogistics.vue?vue&type=style&index=0&id=1bbb28dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb28dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbb28dc')) {
      api.createRecord('1bbb28dc', component.options)
    } else {
      api.reload('1bbb28dc', component.options)
    }
    module.hot.accept("./popLogistics.vue?vue&type=template&id=1bbb28dc&scoped=true", function () {
      api.rerender('1bbb28dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popLogistics/popLogistics.vue"
export default component.exports